import axios from "axios";
import React, { lazy, Suspense, useCallback, useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { Button, SubTitle } from "../../Components/CustomComponents/index.js";
import SimpleTable from "../../Components/Table/SimpleTable.js";
import Pagination from "../../Components/Pagination/Pagination.js";
import Toast, { SuccessToast } from "../../Hooks/useToast.js";
import styles from "./styles/user_management.module.scss";
// import { ToastContainer, toast } from "react-toastify";
import { FaUserEdit } from "react-icons/fa";
//
import { useDispatch } from "react-redux"; // for getting and setting data into local redux
// import CustomerBlockModal from "../../Components/Modals/CustomerBlockModal";
import { debounce } from "lodash";
import { Col, Row, Spinner } from "react-bootstrap";
import { MdDeleteForever } from "react-icons/md";
import DeleteModal from "../../Components/Modals/DeleteModal.js";
import EditReportTypeModal from "../../Components/Modals/EditReportTypeModal.js";
import { useDeleteReportTypeMutation, useGetAllReportTypeQuery } from "../../Data/services/reportTypeApi.js";
import CustomLoader from "../../Components/CustomComponents/CustomLoader.js";
const CustomerBlockModal = lazy(() =>
  import("../../Components/Modals/CustomerBlockModal.js")
);

const ReportTypeManagementScreen = ({ setPage }) => {
  const dispatch = useDispatch();

  // const [data, setData] = useState([]);
  const [indicationMessage, setIndicationMessage] = useState("loading...");
  const [rowData, setRowData] = useState([]);
  const [editedData, setEditedData] = useState("");

  const [loading, setLoading] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const [currentPage, setCurrentPage] = useState(1); // todo
  const [pageSize, setPageSize] = useState(10); // todo
  const [totalRecords, setTotalRecords] = useState(0); // todo
  const [totalPages, setTotalPages] = useState(0); // todo
  const [dataFetched, setDataFetched] = useState(false); // todo

  const [searchQuery, setSearchQuery] = useState("");

  const { data, isSuccess, isLoading, isFetching, refetch } =
    useGetAllReportTypeQuery(
      {
        search: searchQuery.length >= 3 ? searchQuery : "",
        limit: pageSize,
        page: currentPage,
      },
      { refetchOnMountOrArgChange: true }
    );

  useEffect(() => {
    if (data) {
      // console.log(data);
      setPageSize(data.links.per_page);
      setCurrentPage(data.links.current);
      setTotalRecords(data.links.total_records);
      setTotalPages(data.links.total);
      setRowData(data.data);
      setDataFetched(true);
    }
  }, [data]);

  const handleSearchChange = (event) => {
    const query = event.target.value;
    // console.log("Search query:", query); // You can use this to trigger a search function
    setSearchQuery(query);
  };


  const handleDeleteModalOpen = () => {
    setDeleteModal(true);
  };

  const handleDeleteModalClose = () => {
    setDeleteModal(false);
    setEditedData("");
  };

  const handleEditModalOpen = () => {
    setEditModal(true);
  };

  const handleEditModalClose = () => {
    setEditModal(false);
    setEditedData("");
  };

  const handleAddUser = () => {
    setEditModal(true);
  };

  const[deleteReportType, {isLoading: isDeleting}] = useDeleteReportTypeMutation();

  const deleteData = async (slug) => {
    try {
      const { data } = await deleteReportType(slug);
      if (data.code === 200) {
        await refetch();
        handleDeleteModalClose();
        SuccessToast(data.message);
      }
    } catch (error) {
      // console.log(error);
      Toast(error.message, "error");
    }
    
  };



  function indication() {
    // return something here
    // return 'Table is empty';
    return indicationMessage;
  }

  const columns = [
    {
      dataField: "name",
      text: "Report Type",
      sort: true,
      headerStyle: {
        width: "200px",
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "100px",
      },
      formatter: (cellContent, row) => {
        // console.log(row)
        if (row.slug) {
          return (
            <div className={`${styles.mobileActions} d-flex justify-content-center align-items-center gap-2`}>
              <button
                className={`${styles.actionButton} ${styles.editBtn}`}
                onClick={() => {
                  setEditedData(row);
                  handleEditModalOpen(true);
                }}
                title="Edit Report Type"
              >
                <FaUserEdit />
                <span>Edit</span>
              </button>

              <button
                className={`${styles.actionButton} ${styles.deleteBtn}`}
                onClick={() => {
                  setEditedData(row);
                  handleDeleteModalOpen();
                }}
                title="Delete Report Type"
              >
                <MdDeleteForever />
                <span>Delete</span>
              </button>
            </div>
          );
        }
      },
    },
  ];

  return (
    <div className={styles.MainContainer}>
      {deleteModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <DeleteModal
            handleDeleteModalClose={handleDeleteModalClose}
            data={editedData}
            isDeleting={isDeleting}
            onDelete={deleteData}
          />
        </Suspense>
      ) : (
        ""
      )}

      {editModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <EditReportTypeModal
            handleEditModalClose={handleEditModalClose}
            editData={editedData}
            refetch={refetch}
          />
        </Suspense>
      ) : (
        ""
      )}

      <div className={styles.headerContainer}>
        <div className={styles.titleSection}>
          <SubTitle text={"Report Types"} classes="text-black" />
        </div>

        <div className={styles.buttonSection}>
          <Button
            classes={`${styles.addTypeBtn}`}
            text="Add Type"
            onClick={handleAddUser}
          />
        </div>
      </div>

      <div className={styles.mainTable}>
      {!dataFetched || !isSuccess ? (
          <CustomLoader />
        ) : (
        <div className={styles.mainTable}>
          <div className={styles.tableContent}>
            <SimpleTable 
              data={rowData} 
              columns={columns} 
              indication={indication}
              totalRecords={totalRecords}
              totalPages={totalPages}
              pageSize={pageSize}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              setPageSize={setPageSize}
              refetch={refetch}
              showPagination={false}
            />
          </div>
        </div>
      )}

      {/* Pagination outside the table div */}
      {dataFetched && isSuccess && totalPages > 1 && (
        <div className={styles.paginationWrapper}>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            totalRecords={totalRecords}
            pageSize={pageSize}
            onPageChange={(page) => {
              setCurrentPage(page);
              if (refetch) {
                refetch();
              }
            }}
            onPageSizeChange={(newSize) => {
              setPageSize(newSize);
              setCurrentPage(1);
              if (refetch) {
                refetch();
              }
            }}
            showPageSizeSelector={true}
            showRecordsInfo={true}
          />
        </div>
      )}
      </div>
    </div>
  );
};

export default ReportTypeManagementScreen;
